<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.CITYNAME"
        nolabel
        :placeholder="$t('search.cityname')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        CITYNAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        CITYNAME: null,
      };
    },
  },
};
</script>

<style></style>
